module.exports = __webpack_public_path__ + "static/media/CLA_CSV_4.c7203d30.svg";